import Vue, { DirectiveBinding, DirectiveOptions, VNode, VueConstructor } from 'vue';

interface HTMLElementWithHandler extends HTMLElement {
    hash: string;
    href: string;
    __vueClickOutside__?: (e: MouseEvent) => any;
}

const definition: DirectiveOptions = {
    bind: function (el: HTMLElement, binding: DirectiveBinding, vNode: VNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== 'function') {
            const compName = vNode.context?.$options.name;
            let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
            if (compName) { warn += `Found in component '${compName}'`; }
            console.warn(warn); // eslint-disable-line no-console
        }
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble;
        const handler = (e: MouseEvent) => {
            if (bubble || (e.target instanceof Node && !el.contains(e.target) && el !== e.target)) {
                binding.value(e);
            }
        };
        (<HTMLElementWithHandler>el).__vueClickOutside__ = handler;

        // add Event Listeners
        document.addEventListener('click', handler);
    },
    unbind: function (el: HTMLElement) {
        // Remove Event Listeners
        const handler = (<HTMLElementWithHandler>el).__vueClickOutside__;

        if (handler !== undefined) {
            document.removeEventListener('click', handler);
        }
    },
};

const ClickOutside = {
    install (Vue: VueConstructor<Vue>) {
        Vue.directive('click-outside', definition);
    },
};

export default ClickOutside;
